import { render, staticRenderFns } from "./PageViewProject.vue?vue&type=template&id=6b9f1e89"
import script from "./PageViewProject.vue?vue&type=script&lang=js"
export * from "./PageViewProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports